import { PilotOnBoardData } from "../../../entities";
import OldRecordsParser from "../OldRecordsParser";
import { FIXED_PROTOCOL_CONTENT_TYPE_IDS, FIXED_PROTOCOL_TYPE_IDS } from "../../../utils/ProtocolTypeUtils";
const PILOT_ON_BOARD_DATA_TAG = 'PilotOnBoardData';
export default class PilotOnBoardParser extends OldRecordsParser {
    constructor(app) {
        super(FIXED_PROTOCOL_TYPE_IDS.PILOT_ON_BOARD, FIXED_PROTOCOL_CONTENT_TYPE_IDS.PILOT_ON_BOARD, PILOT_ON_BOARD_DATA_TAG, app);
    }
    getPropsMapping() {
        return {
            name: 'name',
            freeText: 'freeText',
            ladPos: 'ladderPosition',
            board: 'boarding',
        };
    }
    createData(props) {
        return new PilotOnBoardData(props.name || '', props.ladderPosition, props.boarding, props.freeText);
    }
}
//# sourceMappingURL=PilotOnBoardParser.js.map